import { render, staticRenderFns } from "./TrainingExpenses.vue?vue&type=template&id=054a143a&scoped=true"
import script from "./TrainingExpenses.vue?vue&type=script&lang=js"
export * from "./TrainingExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054a143a",
  null
  
)

export default component.exports